import React, { useState, useMemo } from 'react';
import styles from '../styles.module.scss';
import cN from 'classnames';
import { useSelector } from 'react-redux';
import { RootState } from '@Redux/search/store';
import { I_FilterOption, I_FilterItemList } from '../interface';
import { displayRtow } from '@utils/formatDisplay';

import CheckboxItem from './CheckboxItem';

interface I_SeqAirports {
    seqNum: number;
    departure: I_FilterOption[];
    arrival: I_FilterOption[];
}

interface I_SeqAirportBlockProps {
    title: string;
    cols: number;
    seqAirports: I_SeqAirports[] | undefined;
    mobileProps?: {
        tempMFilter: I_FilterItemList | null;
        setTempMFilter: Function;
    };
}

// 出發回程機場
const SeqAirportBlock = (props: I_SeqAirportBlockProps) => {
    const moduleName = 'filterBlock';
    const { title, seqAirports, mobileProps } = props;
    const { UrlParams } = useSelector((state: RootState) => state.search);

    const [curSeqIndex, setCurSeqIndex] = useState(0);

    const hasOnlySingleChoice = useMemo(() => {
        let hasSingleChoice = true;
        seqAirports?.forEach((seq) => {
            if (seq.arrival.length > 1 || seq.departure.length > 1) hasSingleChoice = false;
        });
        return hasSingleChoice;
    }, [seqAirports]);

    const handleSwitchTab = (tabIndex: number) => setCurSeqIndex(tabIndex);

    if (hasOnlySingleChoice) return null;
    return (
        <li className={styles[moduleName]}>
            <div className={cN(styles.Block_title)}>
                <div className={cN(styles.Title)}>{title}</div>
            </div>
            <div className={cN(styles.Block_content, { show: true })}>
                {seqAirports && seqAirports?.length > 0 && (
                    <>
                        {seqAirports.length > 1 && (
                            <div className={styles.seqTabs}>
                                {seqAirports.map((_, index) => (
                                    <span
                                        key={index}
                                        className={index === curSeqIndex ? styles.active : ''}
                                        onClick={() => handleSwitchTab(index)}
                                    >
                                        {displayRtow(index + 1, UrlParams.Rtow)}
                                    </span>
                                ))}
                            </div>
                        )}
                        <ul className={cN(styles.CheckBoxes)}>
                            {seqAirports[curSeqIndex].departure?.length > 0 && (
                                <>
                                    <li className={cN(styles.CheckBoxesTitle)}>出發機場</li>
                                    {seqAirports[curSeqIndex].departure.map((child) => {
                                        return (
                                            <CheckboxItem
                                                key={`${child.text}-${child.value}`}
                                                filterType="departure"
                                                cols="col1"
                                                text={child.text}
                                                value={child.value}
                                                curSeq={curSeqIndex + 1}
                                                isDisable={child.disable}
                                                {...mobileProps}
                                            />
                                        );
                                    })}
                                </>
                            )}

                            {seqAirports[curSeqIndex].arrival?.length > 0 && (
                                <>
                                    <li className={cN(styles.CheckBoxesTitle)}>抵達機場</li>
                                    {seqAirports[curSeqIndex].arrival.map((child) => {
                                        return (
                                            <CheckboxItem
                                                key={`${child.text}-${child.value}`}
                                                filterType="arrival"
                                                cols="col1"
                                                text={child.text}
                                                value={child.value}
                                                curSeq={curSeqIndex + 1}
                                                isDisable={child.disable}
                                                {...mobileProps}
                                            />
                                        );
                                    })}
                                </>
                            )}
                        </ul>
                    </>
                )}
            </div>
        </li>
    );
};

export default SeqAirportBlock;
